import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { memo as h } from "react";
import y from "../Flex/Flex.js";
import i from "./Banner.module.scss.js";
import { FeaturedIcon as C } from "../FeaturedIcon/FeaturedIcon.js";
import { Typography as s } from "../Typography/Typography.js";
import b from "../Icon/Icon.js";
import w from "../CompactButton/CompactButton.js";
import N from "../LinkButton/LinkButton.js";
import { clsx as f } from "../../../node_modules/clsx/dist/clsx.m.js";
import p from "../Button/Button.js";
const k = (g) => {
  const {
    title: d,
    description: o,
    learnMore: c,
    onClickLearnMore: u,
    size: r = "compact",
    color: a = "neutral",
    variant: t = "filled",
    leadingIcon: l,
    onClose: m,
    footer: n,
    testId: j
  } = g, x = r === "extended" && t === "filled", v = a === "warning" || t == "tinted";
  return /* @__PURE__ */ e.jsxs(
    y,
    {
      flexCol: !0,
      "data-testid": j,
      children: [
        (d || o && r === "compact") && /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: f(i.headerContainer, i[a], i[t], {
              [i.compact]: r === "compact",
              [i.extended]: r === "extended" && t === "filled",
              [i.headerContainerTinted]: t === "tinted" && r == "extended"
            }),
            children: [
              /* @__PURE__ */ e.jsx("div", { className: i.fancy }),
              /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between w-full gap-100", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-100", children: [
                  l && (t === "tinted" ? /* @__PURE__ */ e.jsx("div", { className: "rounded-[100%] shadow-ambient", children: /* @__PURE__ */ e.jsx(
                    C,
                    {
                      iconName: l,
                      variant: "tinted",
                      colorType: a,
                      rounded: !0
                    }
                  ) }) : /* @__PURE__ */ e.jsx(
                    b,
                    {
                      size: "md",
                      name: l
                    }
                  )),
                  /* @__PURE__ */ e.jsxs(
                    "div",
                    {
                      className: `flex flex-col justify-center ${d && o ? "gap-050" : ""}`,
                      children: [
                        /* @__PURE__ */ e.jsx(
                          s,
                          {
                            text: d,
                            variant: "interface/strong/sm",
                            textColor: t !== "tinted" && a == "warning" ? "color/fg/warning/bold" : t == "tinted" ? "color/fg/default" : "color/fg/inverse"
                          }
                        ),
                        o && !x && /* @__PURE__ */ e.jsx(
                          s,
                          {
                            text: o,
                            variant: "body-new/medium",
                            textColor: a == "warning" && t != "tinted" ? "color/fg/warning/bold" : t == "tinted" ? "color/fg/light" : "color/fg/inverse-light"
                          }
                        )
                      ]
                    }
                  )
                ] }),
                !(t == "filled" && r === "extended") && c && /* @__PURE__ */ e.jsx("div", { className: "flex flex-shrink-0", children: /* @__PURE__ */ e.jsx(
                  N,
                  {
                    variant: v ? "neutral" : "inversed",
                    size: "medium",
                    onClick: u,
                    label: c
                  }
                ) })
              ] }),
              m && /* @__PURE__ */ e.jsx(
                w,
                {
                  variant: t == "filled" && a == "warning" || t == "tinted" ? "ghost" : "ghost-inversed",
                  icon: "x",
                  size: "medium",
                  onClick: m
                }
              )
            ]
          }
        ),
        o && r == "extended" && /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: f(i.bodyContainer, i[a], {
              "rounded-small": !d,
              [i.footerContainerTinted]: t === "tinted" && r === "extended"
            }),
            children: [
              o && x && /* @__PURE__ */ e.jsx(
                s,
                {
                  text: o,
                  variant: "body-new/medium",
                  textColor: "color/fg/light"
                }
              ),
              n && /* @__PURE__ */ e.jsxs("div", { className: "flex gap-100", children: [
                n.primary && /* @__PURE__ */ e.jsx(
                  p,
                  {
                    color: "neutral",
                    variant: "outlined",
                    size: "medium",
                    onClick: n.primary.onClick,
                    disabled: n.primary.disabled,
                    label: n.primary.label,
                    testId: n.primary.testId
                  }
                ),
                n.secondary && /* @__PURE__ */ e.jsx(
                  p,
                  {
                    color: "neutral",
                    variant: "ghost",
                    size: "medium",
                    disabled: n.secondary.disabled,
                    label: n.secondary.label,
                    onClick: n.secondary.onClick,
                    testId: n.secondary.testId
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, W = h(k);
export {
  W as default
};
//# sourceMappingURL=Banner.js.map
